import { useContext, useEffect, useState } from "react";

import Selector from "components/selector/selector.component";
import Table from "components/table/table.component";
import Folder from "components/folder/folder.component";
import SidebarFolder from "components/sidebar/sidebar-folder/sidebar-folder.component";
import LockProgress from "./components/lock-progress/lock-progress.component";

import { FolderContext } from "src/contexts/folder.context";

import "./archive-tab.style.scss";

const FOLDERS = {
	ACHANTS: {
		isLocked: false,
		progress: [[1, 2, 3, 4, 5, 6], 6],
		files: {
			"Quarter 1": {
				isLocked: false,
				files: {},
			},
			"Quarter 2": {
				isLocked: false,
				files: {},
			},
			"Quarter 3": {
				isLocked: false,
				files: {},
			},
			"Quarter 4": {
				isLocked: false,
				files: {},
			},
		},
	},
	VENTES: {
		isLocked: false,
		progress: [[1, 2, 3], 4],
		files: {
			"Quarter 1": {
				isLocked: false,
				files: {},
			},
			"Quarter 2": {
				isLocked: false,
				files: {},
			},
			"Quarter 3": {
				isLocked: false,
				files: {},
			},
			"Quarter 4": {
				isLocked: false,
				files: {},
			},
		},
	},
	FISCALE: {
		isLocked: false,
		progress: [[1], 1],
		files: {
			"Quarter 1": {
				isLocked: false,
				files: {},
			},
			"Quarter 2": {
				isLocked: false,
				files: {},
			},
			"Quarter 3": {
				isLocked: false,
				files: {},
			},
			"Quarter 4": {
				isLocked: false,
				files: {},
			},
		},
	},
	FINANCIERS: {
		isLocked: false,
		progress: [[], 1],
		files: {
			"Quarter 1": {
				isLocked: false,
				files: {},
			},
			"Quarter 2": {
				isLocked: false,
				files: {},
			},
			"Quarter 3": {
				isLocked: false,
				files: {},
			},
			"Quarter 4": {
				isLocked: false,
				files: {},
			},
		},
	},
	TVA: {
		isLocked: false,
		progress: [[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], 12],
		files: {
			"Quarter 1": {
				isLocked: false,
				files: {},
			},
			"Quarter 2": {
				isLocked: false,
				files: {},
			},
			"Quarter 3": {
				isLocked: false,
				files: {},
			},
			"Quarter 4": {
				isLocked: false,
				files: {},
			},
		},
	},
};

const ArchiveTab = () => {
	const { focusedFiles, goBack, currentLocation, files, addFolder } = useContext(FolderContext);

	const [breadcrumbs, setBreadcrumbs] = useState("");

	useEffect(() => {
		const str = currentLocation.join(" > ");
		setBreadcrumbs(str.toUpperCase());
	}, [currentLocation]);

	const handleGoBack = () => {
		goBack();
	};

	return (
		<div className="archive-tab-container scroll-bar scroll-bar--overflow">
			{/* selector and right side line + breadcrumbs */}
			<div className="flex gap-xxxl">
				<div className="flex flex--end-items gap-xxl padding-m--bottom sticky selector-wrapper">
					<Selector data={[2019, 2020, 2021, 2022]} selected={2022} />
				</div>
				<div className="home-header">
					{breadcrumbs.length > 0 && (
						<div className="flex flex--center-items gap-l size400 w600 ">
							<ion-icon onClick={handleGoBack} name="arrow-back-outline" />
							<div className="breadcrumbs">{breadcrumbs}</div>
						</div>
					)}
				</div>
			</div>

			{/* folders and lock progress */}
			<div className={`flex gap-xxxl`}>
				<div>
					{Object.keys(FOLDERS).map((folder, index) => {
						const data = FOLDERS[folder];
						const childrenFolders = data?.files;
						const isEmpty = Object.keys(childrenFolders ?? {})?.length === 0;

						return (
							<div key={index} className="fixed-height size400">
								<SidebarFolder folderName={folder} isEmpty={isEmpty} />
							</div>
						);
					})}
				</div>

				{breadcrumbs.length === 0 ? (
					<div className="flex flex--column flex--grow">
						{Object.keys(FOLDERS).map((folder, index) => {
							const data = FOLDERS[folder];
							const progress = data?.progress;
							return (
								<div key={index} className="fixed-height size400">
									<LockProgress lockedBoxes={progress[0]} allBoxes={progress[1]} />
								</div>
							);
						})}
					</div>
				) : (
					<div className="flex flex--grow flex--column">
						<div className="folders-container flex flex--wrap gap-s">
							<Folder addButton size="small" />
							{focusedFiles.folders.map(({ fileName, isEmpty }, index) => {
								return <Folder key={index} fileName={fileName} isEmpty={isEmpty} size="small" />;
							})}
						</div>
						<Table />
					</div>
				)}
			</div>
		</div>
	);
};

export default ArchiveTab;
